// Reading numbers the way a spreadsheet wrote them.
//
// Everything pasted into an EVA grid comes out of Excel, so "1.234,56",
// "1,234.56", "99 200" and "€1 234" all mean a number. A bare Number() turns
// most of those into NaN, which the grids then store as null — the value is
// gone and nothing says so. This is the one place that decides what a separator
// means; the Ruby side does the same job in Operations::RentRolls::Import.

// - Both comma and dot: the LAST separator is the decimal one
//     "1,234.56" → 1234.56, "1.234,56" → 1234.56
// - Only commas, exactly 3 digits after: thousands   "99,200" → 99200
// - Only commas, other digit counts: decimal         "99,20"  → 99.20
// - Several commas: thousands                        "1,234,567" → 1234567
// - Several dots, no comma: thousands                "1.234.567" → 1234567
// - Spaces between digits: thousands                 "99 200" → 99200
export function normalizeNumericValue(value) {
  if (typeof value !== 'string') return value
  let s = value.trim()
  if (s === '') return s

  let prefix = ''
  if (s.startsWith('-')) { prefix = '-'; s = s.slice(1) }

  s = s.replace(/[€£$¥₽]/g, '')
  s = s.replace(/(\d)[\s  ]+(?=\d)/g, '$1')
  s = s.trim()
  if (s === '') return value

  const commas = (s.match(/,/g) || []).length
  const dots = (s.match(/\./g) || []).length

  if (commas > 0 && dots > 0) {
    if (s.lastIndexOf(',') > s.lastIndexOf('.')) {
      return prefix + s.replace(/\./g, '').replace(',', '.')
    }
    return prefix + s.replace(/,/g, '')
  }

  if (commas > 0) {
    if (commas > 1) return prefix + s.replace(/,/g, '')
    const afterComma = s.split(',')[1]
    if (/^\d{3}$/.test(afterComma)) return prefix + s.replace(',', '')
    return prefix + s.replace(',', '.')
  }

  if (dots > 1) return prefix + s.replace(/\./g, '')

  return prefix + s
}

// Spreadsheet-aware Number(): returns null rather than NaN so a caller can tell
// "not a number" from "zero", and understands a trailing percent sign.
export function parseNumericInput(value) {
  if (value === null || value === undefined || value === '') return null

  const raw = String(value).trim()
  if (raw === '') return null

  const withoutPercent = raw.endsWith('%') ? raw.slice(0, -1).trim() : raw
  const n = Number(normalizeNumericValue(withoutPercent))

  return Number.isFinite(n) ? n : null
}
